// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__15d4t","buttonCaption":"button_buttonCaption__1UnGx","spinner":"button_spinner__3emAo"};